import { freeze as t } from "./highrise1720.mjs";
var s = /* @__PURE__ */ function() {
  function e(i, r) {
    this.inlineSize = i, this.blockSize = r, t(this);
  }
  return e;
}();
export {
  s as ResizeObserverSize
};
